import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import InputRow from './inputRow';
import { isValid, isValidPhone, isValidEmail, genderValues, ageGroupValues, experienceValues, judgeClassValues } from "../../../api"


class TournamentProfile extends Component {
  constructor(props) {
    super(props);
    this.onDataChange = this.onDataChange.bind(this);
    const data = this.props.data;
    data.judgeClass = this.props.judgeClass ? this.props.judgeClass : data.judgeClass;

    this.state = { open: false, data: data, tournamentMode: this.props.tournamentMode}
    this.original = JSON.parse(JSON.stringify(this.props.data))
  }

  onCloseModal = () => {
    this.setState({ data: JSON.parse(JSON.stringify(this.original)), open: false });    
};

  onDataChange(evt) {
    
    const id = evt.target.id
    var val = evt.target.value
    if (id === 'guestOfEmail') val = val.toLowerCase().trim();

    let state = this.state;
    state.data[id] = val;

    this.setState(state);
    
  }


  
  getApprovable(state) {
    var approvable = true;
    if (state) {
      const {data} = state;
      if (state.tournamentMode) {
        approvable &= isValid(data.judgeClass);
        approvable &= (data.judgeClass !== 'guest' || isValidEmail(data.guestOfEmail));
      }
      approvable &= isValid(data.experience);
      approvable &= isValid(data.gender);
      approvable &= isValid(data.age);
      //approvable &= isValid(data.club, 3); // not mandating club
      approvable &= isValidPhone(data.phone);
    }

    return approvable;
  }

  
  componentDidUpdate(prevProps) {
    if(prevProps.data !== this.props.data || prevProps.open !== this.props.open || prevProps.judgeClass !== this.props.judgeClass) {
      const data = this.props.data;
      data.judgeClass = this.props.judgeClass ? this.props.judgeClass : data.judgeClass;
      this.setState({ open: this.props.open, data: data});
    }
}

  render() {
    var { data } = this.state;

    if (!data.club) data.club = "";
    if (!data.experience) data.experience = "";
    if (!data.gender) data.gender = "";
    if (!data.judgeClass) data.judgeClass = "";
    if (!data.guestOfEmail) data.guestOfEmail = "";
    if (!data.age) data.age = "";
    if (!data.phone) data.phone = "";

    var judgeText = "(If unsure, select 'Community')"
    if (this.props.lockedJudgeClass) {
      if (data.judgeClass === 'competitor') judgeText = "(Locked because you have already registered for events)"
      else judgeText = "Locked because you have set your round availability"
    }

    return (
      <>
      {!this.props.hideDisplayBox &&
      <div className="box">
        <div className="box-title">
          {!this.props.readOnly && <h3>{this.props.title} &nbsp;&nbsp;<button className="badge badge-info" onClick={() => {this.setState({open: true})}}>Edit Profile</button></h3>}
          {this.props.readOnly && <><h3 style={{display: "inline"}}>{this.props.title}</h3><span style={{marginLeft: "20px", display: "inline", fontSize: "10px"}}>(Edit in your Dashboard)</span> </>}
        </div>
          <div className="box-content">
              <div>
                {this.props.tournamentMode &&
                <>
                <h6>Participant Category: <span><b>{judgeClassValues(data.judgeClass) || 'not set'}</b></span></h6>
                {data.judgeClass === 'guest' && <h6>Guest Of: <span><b>{data.guestOfEmail || 'not set'}</b></span></h6>}
                </>
                }
                <h6>Club Affiliation: <span><b>{data.club || 'not set'}</b></span></h6>
                <h6>Speech and Debate Experience: <span><b>{`${experienceValues(data.experience) || 'not set'}`}</b></span></h6>
                <h6>Gender: <span><b>{genderValues(data.gender) || 'not set'}</b></span></h6>
                <h6>Age Group: <span><b>{ageGroupValues(data.age) || 'not set'}</b></span> </h6>
                <h6>Phone #: <span><b>{data.phone || 'not set'}</b></span> </h6>
              </div>
          </div>
        </div> 
      }       

      <Modal open={this.state.open} onClose={this.onCloseModal} >
            <div className="modal-header">
              <h4 className="modal-title f-w-600" id="exampleModalLabel2">Update Tournament Profile <small style={{color: "red"}}>Items in red are required</small></h4>
            </div>
            <div className="modal-body">
                    {this.props.tournamentMode && <>
                    <p>If you will not be judging or competing, you are a guest.</p>
                    {this.props.lockedOutCompetitors
                    ?
                    <InputRow disabled={this.props.lockedJudgeClass} type="radio" name="judgeClass" required title="Participant Category" value={data.judgeClass} options={[
                        ['alumni', 'Alumni'],
                        ['parent', 'Parent'],
                        ['community', 'Community'],
                      ]} 
                      note={judgeText}
                      onChange={this.onDataChange}
                    />
                    :
                    <InputRow disabled={this.props.lockedJudgeClass} type="radio" name="judgeClass" required title="Participant Category" value={data.judgeClass} options={[
                      ['competitor', 'Competitor'],
                      ['alumni', 'Alumni'],
                      ['parent', 'Parent'],
                      ['community', 'Community'],
                    ]} 
                    note={judgeText}
                    onChange={this.onDataChange}
                    />
                    }
                    </>}
                    
                  {data.judgeClass === 'guest' &&
                  <InputRow type="text" name="guestOfEmail" title="Guest of Whom?" value={data.guestOfEmail} 
                  placeholder="Enter the email address"
                  onChange={this.onDataChange}
                  />
                  }

                    <InputRow type="text" name="club" title="Club affiliation" value={data.club} 
                    placeholder="Club name"
                    onChange={this.onDataChange}
                    />

                    <InputRow type="radio" name="experience" required title="Speech and Debate Experience (years)" value={data.experience} options={[
                        ['u01', 'None'],
                        ['r01', '1-2'],                        
                        ['r03', '3-4'],
                        ['o04', '5 and above'],
                      ]} 
                      onChange={this.onDataChange}
                    />

                    <InputRow type="radio" name="gender" required title="Gender" value={data.gender} options={[
                        ['male', 'Male'],
                        ['female', 'Female'],
                      ]} 
                      onChange={this.onDataChange}
                    />

                    <InputRow type="radio" name="age" required title="Age Group" value={data.age} options={[
                      ['u13', '12 and younger'],
                      ['r13', '13 - 14'],                        
                      ['r15', '15 - 16'],
                      ['r17', '17 - 19'],
                      ['r20', '20 - 27'],                        
                      ['r28', '28 - 37'],
                      ['r38', '38 - 57'],
                      ['o57', '58 and above'],
                      ]} 
                      onChange={this.onDataChange}
                    />

                    <InputRow type="text" name="phone" required title="Phone Number" value={data.phone}
                      placeholder="Phone"
                      note="(Used only for this tournament when your attention is required)"
                      onChange={this.onDataChange}
                    />

            </div>
            <div className="modal-footer" style={{paddingTop: "6px", paddingBottom: "6px"}}>              
              <button type="button" className="btn btn-secondary" onClick={this.onCloseModal}>Cancel</button>
              <button type="button" className="btn btn-primary" 
                disabled={!this.getApprovable(this.state)} 
                onClick={() => { this.setState({open: false}); this.props.onCloseModal('tournamentProfile', this.state.data)}}>Approve</button>
            </div>
          </Modal>
          </>
      );
  }
}

export default TournamentProfile;

